'use strict';

var CANVAS_IMAGE_DRAG = {
  width: 128,
  height: 128
};

var ImageSizes = {
  EDITOR_GRABBAG_ITEM_DRAG: {
    width: 64,
    height: 64
  },

  EDITOR_GALLERY_IMAGE_DRAG: CANVAS_IMAGE_DRAG,

  EDITOR_COVER_DRAG: CANVAS_IMAGE_DRAG,

  EDITOR_POSTER_DRAG: CANVAS_IMAGE_DRAG
};

module.exports = ImageSizes;



/** WEBPACK FOOTER **
 ** ./constants/ImageSizes.js
 **/